import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Clipboard } from "@angular/cdk/clipboard";
import {
  NbComponentStatus,
  NbDialogRef,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";
// import { ClipboardService } from "ngx-clipboard";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "ngx-dialog-share-link",
  templateUrl: "dialog-share-link.component.html",
  styleUrls: ["dialog-share-link.component.scss"],
})
export class DialogShareLinkComponent implements OnInit {
  @Input() title?: string;
  @Input() link: string;

  submitted = false;

  constructor(
    protected ref: NbDialogRef<DialogShareLinkComponent>,
    // private clipboardApi: ClipboardService,
    private clipboardApi: Clipboard,
    private toastrService: NbToastrService,
    private router: Router,
  ) {}

  ngOnInit() {}

  close() {
    this.ref.close();
  }

  copyLink() {
    // this.clipboardApi.copyFromContent(this.link);
    const ok = this.clipboardApi.copy(this.link);
    if (ok) {
      this.showToast(
        "success",
        "Đã copy link chia sẻ dữ liệu thành công",
        this.link,
      );
    } else {
      this.showToast("warning", "Copy thất bại", "Xin vui lòng thử lại");
    }
  }

  openLink() {
    window.open(this.link, "_blank");
    // this.router.navigateByUrl(this.link);
  }

  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
